import React, { useEffect, useState } from 'react'
import { Container, Typography } from '@material-ui/core';
import { useInterval } from '../../../hooks/useInterval'
import { StatusMap } from '../../../../enum/CreateCartoMaps'
import { getCartoRecordsForAccount } from "../../../../services/backendApi";
import { useVisualisationsState, useVisualisationsDispatch } from '../../../contexts/visualisations-context'
import ExistingMapsTable from './ExistingVisualisationsTable'

const ExistingMaps = ({ accountId }) => {
    const INTERVAL_DELAY = 5000 // 5 seconds
    const { visualisationsList, requiresListUpdate } = useVisualisationsState()
    const { updateVisualisationsList } = useVisualisationsDispatch()
    const [ isZonesCreationInProgress, setIsZonesCreationInProgress ] = useState(true)

    useEffect(() => {
        setIsZonesCreationInProgress(visualisationsList.some(vis => (
            vis.status === StatusMap.PENDING.status
            || vis.status === StatusMap.IMPORTING_DATASETS.status
            || vis.status === StatusMap.CREATING_MAP.status)))
    }, [visualisationsList])

    useEffect(() => {
        if (requiresListUpdate) getVisualisationsList()
    }, [ requiresListUpdate ])

    useInterval(() => getVisualisationsList(), isZonesCreationInProgress ? INTERVAL_DELAY : null )

    const getVisualisationsList = async () => {
        try {
            const visData = await getCartoRecordsForAccount(accountId)
            updateVisualisationsList(visData.Items)
        } catch (error) {
            console.log('error', error)
            alert('There was an issue retreiving list of visualisations from DynamoDB')
        }
    }

    return (
        <Container maxWidth="xl" className="white-card list-container">
            <h5 className="title">EXISTING VISUALISATIONS</h5>
            { 
                visualisationsList.length ? 
                    <ExistingMapsTable /> :
                    <Typography variant="subtitle1">There are no map visualisations for this account. Click on Create New Map Visualisation button to create one.</Typography>  
            }
        </Container>
    )
}

export default ExistingMaps